import React from "react";
import { Helmet } from "react-helmet";
import "../css/privacy-policy.css";

const PrivacyPolicy = () => {
  return (
    <div>
      <Helmet>
        <title>Privacy Policy | Ruturaj Enterprises</title>

        <meta
          name="description"
          content="Privacy Policy for Ruturaj Enterprises. Learn how we collect, use, and protect your personal information when using our cab, taxi, tempo traveller, bus rental, local and outstation travel services."
        />

        <meta
          name="keywords"
          content="Ruturaj Enterprises, Ruturaj Enterprises Pune, Cab Service, Taxi Booking, Tempo Traveller on Rent, Bus Rental, Airport Transfer, Outstation Travel, Privacy Policy"
        />
      </Helmet>

      {/* Breadcrumb */}
      <div
        className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
        style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                <div className="section-title-area ltn__section-title-2">
                  <h1 className="section-title white-color">
                    Privacy Policy
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Privacy Policy Section */}
      <section className="privacy-policy">
        <div className="container px-0">
          <div className="row g-0">

            <img
              src="/images/privacy.webp"
              alt="Privacy Policy - Ruturaj Enterprises"
            />

            <div className="col-12 col-md-12">

              <h3 className="title">
                Privacy Policy – Ruturaj Enterprises
              </h3>

              <p>
                At <b>Ruturaj Enterprises</b>, we respect your privacy and
                are committed to protecting your personal information. This
                Privacy Policy explains how we collect, use, and safeguard
                your information when you use our cab, taxi, tempo traveller,
                bus rental, local travel, airport transfer, sightseeing, and
                outstation travel services.
              </p>

              {/* Information We Collect */}
              <div className="section">
                <p className="highlight darkcolor">
                  Information We Collect:
                </p>

                <p className="highlight darkcolor">
                  1. Personal Information:
                </p>

                <p>
                  We may collect your name, mobile number, email address,
                  pickup and drop locations, travel dates, passenger details,
                  and payment information when you make a booking with us.
                </p>

                <p className="highlight darkcolor">
                  2. Booking Information:
                </p>

                <p>
                  We collect booking-related information such as travel
                  routes, vehicle type, number of passengers, pickup time,
                  destination, and trip requirements to provide smooth and
                  reliable transportation services.
                </p>

                <p className="highlight darkcolor">
                  3. Device & Usage Data:
                </p>

                <p>
                  We may collect basic technical information such as device
                  information, browser type, IP address, and website usage
                  data to maintain and improve our website and services.
                </p>
              </div>

              {/* How We Use Information */}
              <div className="section">
                <p className="highlight darkcolor">
                  How We Use Your Information:
                </p>

                <p className="highlight darkcolor">
                  1. Booking & Service Delivery:
                </p>

                <p>
                  To process your booking, arrange the requested vehicle,
                  coordinate with drivers, and provide transportation services.
                </p>

                <p className="highlight darkcolor">
                  2. Customer Support:
                </p>

                <p>
                  To provide booking confirmations, trip updates, invoices,
                  customer assistance, and other service-related communication.
                </p>

                <p className="highlight darkcolor">
                  3. Service Improvement:
                </p>

                <p>
                  To understand customer feedback, analyze website usage,
                  improve our vehicles and services, and provide a better
                  travel experience.
                </p>

                <p className="highlight darkcolor">
                  4. Marketing:
                </p>

                <p>
                  With your consent, we may send information about offers,
                  travel services, packages, and updates. You may opt out of
                  promotional communications at any time.
                </p>
              </div>

              {/* Information Sharing */}
              <div className="section">
                <p className="highlight darkcolor">
                  Information Sharing:
                </p>

                <p className="highlight darkcolor">
                  1. Drivers:
                </p>

                <p>
                  Necessary booking information may be shared with the assigned
                  driver to complete your journey and provide the requested
                  transportation service.
                </p>

                <p className="highlight darkcolor">
                  2. Service Providers:
                </p>

                <p>
                  We may share limited information with trusted service
                  providers, payment partners, technology providers, or other
                  partners when required to provide our services.
                </p>

                <p className="highlight darkcolor">
                  3. Legal Requirements:
                </p>

                <p>
                  We may disclose information when required by applicable law,
                  court orders, government authorities, or other legal
                  requirements.
                </p>
              </div>

              {/* Security */}
              <div className="section">

                <p className="highlight darkcolor">
                  Data Security:
                </p>

                <p>
                  We take reasonable and appropriate security measures to
                  protect your personal information from unauthorized access,
                  misuse, alteration, disclosure, or loss.
                </p>

                <p className="highlight darkcolor">
                  Data Retention:
                </p>

                <p>
                  Personal information is retained only for as long as
                  reasonably necessary to provide our services, maintain
                  business records, resolve disputes, and comply with
                  applicable legal requirements.
                </p>

                <p className="highlight darkcolor">
                  Your Rights:
                </p>

                <p>
                  You may contact us to request access to, correction of, or
                  deletion of your personal information, subject to applicable
                  legal and operational requirements.
                </p>

                <p className="highlight darkcolor">
                  Cookies:
                </p>

                <p>
                  Our website may use cookies and similar technologies to
                  improve website functionality, user experience, analytics,
                  and service performance.
                </p>

                <p className="highlight darkcolor">
                  Third-Party Links:
                </p>

                <p>
                  Our website may contain links to third-party websites or
                  services. Ruturaj Enterprises is not responsible for the
                  privacy practices, content, or policies of external websites.
                </p>

                <p className="highlight darkcolor">
                  Policy Updates:
                </p>

                <p>
                  Ruturaj Enterprises may update this Privacy Policy from time
                  to time. Any changes will be reflected on this page with the
                  updated policy information.
                </p>

              </div>
            </div>
          </div>

          {/* Contact Info */}
          <div className="contact-info">

            <h2>Contact Ruturaj Enterprises</h2>

            <p>
              For any privacy-related queries, questions, or requests,
              please contact us:
            </p>

            <ul>
              <li>
                <b>Phone:</b>{" "}
                <a href="tel:+919763381382">
                  +91 9763381382
                </a>
              </li>

               <li>
                <b>Email:</b>{" "}
                <a href="mailto:booking@ruturajenterprises.com">
                  booking@ruturajenterprises.com
                </a>
              </li>

               <li>
                <b>Address:</b>
                <br />
                Ruturaj Enterprises,<br />
                Nandini Takle Nagar, <br />Pune - Solapur Road Manjri <br />Bk Hadapsar, Pune, Maharashtra 412307


              </li>
            </ul>

          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
